import { Link } from "react-router-dom";

function formatCompact(value) {
  if (!value || value === 0) return null;
  if (value >= 1_000_000_000) return `$${(value / 1_000_000_000).toFixed(1)}B`;
  if (value >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `$${(value / 1_000).toFixed(0)}K`;
  return `$${value.toFixed(0)}`;
}

export default function ProviderPageTabs({
  npi, name, state, specialty, totalPayments,
  ownershipCount, activeOwnershipCount,
  researchCount, researchPayments, researchYears,
  activePage,
}) {
  const baseParams = `name=${encodeURIComponent(name)}&state=${encodeURIComponent(state)}&specialty=${encodeURIComponent(specialty || "")}&totalPayments=${totalPayments || 0}`;

  const tabs = [
    {
      id: "general",
      icon: "💊",
      label: "General Payments",
      to: `/physician/${npi}?${baseParams}`,
      metric: formatCompact(totalPayments),
      metricLabel: "total all years",
      metricColor: "text-gold-400",
    },
    {
      id: "ownership",
      icon: "🏦",
      label: "Ownership",
      to: `/physician/${npi}/ownership?${baseParams}`,
      metric: ownershipCount > 0 ? String(ownershipCount) : null,
      metricLabel: activeOwnershipCount > 0 ? `${activeOwnershipCount} active` : "interests",
      metricColor: "text-amber-400",
    },
    {
      id: "research",
      icon: "🔬",
      label: "Research",
      to: `/physician/${npi}/research?${baseParams}`,
      metric: researchCount > 0 ? String(researchCount) : null,
      metricLabel: researchYears > 0
        ? `${researchYears} yr${researchYears !== 1 ? "s" : ""} · ${(researchPayments || 0).toLocaleString()} payments`
        : "companies",
      metricColor: "text-teal-400",
    },
  ];

  return (
    <div className="flex gap-1 bg-navy-800 border border-white/10 rounded-xl p-1 mb-6">
      {tabs.map((tab) => {
        const isActive = tab.id === activePage;
        return (
          <Link
            key={tab.id}
            to={tab.to}
            className={`flex-1 flex flex-col items-center justify-center py-2 px-2 rounded-lg text-xs font-medium transition-all ${
              isActive
                ? "bg-navy-700 text-white border border-white/10"
                : "text-white/40 hover:text-white/70"
            }`}
          >
            <div className="flex items-center gap-1 mb-0.5">
              <span>{tab.icon}</span>
              <span>{tab.label}</span>
            </div>
            {tab.metric ? (
              <>
                <div className={`font-display text-sm leading-tight ${isActive ? tab.metricColor : "text-white/30"}`}>
                  {tab.metric}
                </div>
                <div className="text-white/25" style={{ fontSize: "9px" }}>{tab.metricLabel}</div>
              </>
            ) : (
              <div className="text-white/15 text-xs">—</div>
            )}
          </Link>
        );
      })}
    </div>
  );
}